import gsap from "gsap";

export default function Districts() {
    const areas = document.querySelectorAll(".area");
    const districts = document.querySelectorAll(".district");
    const texts = document.querySelectorAll(".text");

    // Initial pulse animation
    gsap.fromTo(
      districts,
      { autoAlpha: 0, scale: 0.95 },
      { autoAlpha: 1, scale: 1, duration: 0.5, stagger: 0.5, onComplete: hideDistricts }
    );
  
    function hideDistricts() {
      gsap.to(districts, {
        autoAlpha: 0,
        duration: 1,
        onComplete: setActiveDistrictAndArea,
      });
    }
  
    function setActiveDistrictAndArea() {
      const activeDistrict = districts[0];
      const activeArea = areas[0];
      const activeText = texts[0];
      const citytext = document.getElementById("citytext");
      citytext.classList.remove("invisible");
  
      activeDistrict.classList.add("active");
      activeDistrict.style.visibility = "visible";
      activeDistrict.style.opacity = 1;
  
      activeArea.classList.add("active");
  
      activeText.classList.add("active");
      activeText.style.visibility = "visible";
      activeText.style.display = "block";
      activeText.style.opacity = 1;
    }


  
  areas.forEach((area) => {
    area.addEventListener("click", function () {
      const districtId = area.dataset.districtId;
      const district = document.getElementById(districtId);
      const text = document.querySelector(`[data-text-id="${districtId}"]`);
  
      areas.forEach((otherArea) => {
        otherArea.classList.remove("active");
      });
  
      districts.forEach((otherDistrict) => {
        otherDistrict.classList.remove("active");
        otherDistrict.style.opacity = 0;
      });
  
      texts.forEach((otherText) => {
        otherText.classList.remove("active");
        otherText.style.display = "none";
        otherText.style.opacity = 0;
      });
  
      area.classList.add("active");
  
      gsap.fromTo(
        district,
        { autoAlpha: 0, scale: 0.95 },
        { autoAlpha: 1, scale: 1, duration: 0.5 }
      );
  
      district.classList.add("active");
      text.classList.add("active");
      text.style.visibility = "visible";
      text.style.display = "block";
      text.style.opacity = 1;
    });

  
  
  
  
  
  });
  
    
      
}